"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var createRecordFromPath_1 = __importDefault(require("./createRecordFromPath"));
var merge_1 = __importDefault(require("lodash/merge"));
var createRecordWithManyValuePaths = function (paths) {
    return merge_1.default.apply(void 0, __spreadArray([
        // tslint:disable-line
        {}], Object.entries(paths).map(function (_a) {
        var path = _a[0], value = _a[1];
        return (0, createRecordFromPath_1.default)(path, value);
    }), false));
};
exports.default = createRecordWithManyValuePaths;
//# sourceMappingURL=createRecordWithManyPaths.js.map